import React from "react";

const PlacementListingDetail = ({ data }) => {
  return data?.map((data, index) => {
    return (
      <div className="placement_card_wrapper" key={index}>
        <div className="placement_item_card">
          <div className="placement_header">
            <span className="placement_heading">
              {data?.placement || "placement 1"}
            </span>
          </div>
          {data?.products?.map((item, i) => {
            return (
              <>
                <div className="product_card_info">
                  <div className="d-flex justify-content-between px-3 py-1">
                    <span className="crop-plan-detail">Product(N-P-K-S)</span>
                    <span className="crop-plan-detail">{`${
                      item?.productNitrogen || 0
                    }-${item?.productPhosphorus || 0}-${
                      item?.productPotassium || 0
                    }-${item?.productOther || 0}`}</span>
                  </div>
                  <div className="d-flex justify-content-between px-3 py-1">
                    <span className="crop-plan-detail">Rate (LB/AC)</span>
                    <span className="crop-plan-detail">{item?.rate}</span>
                  </div>
                  <div className="d-flex justify-content-between px-3 py-1">
                    <span className="crop-plan-detail">Actual (N-P-K-S)</span>
                    <span className="crop-plan-detail">
                      {item?.actualValue}
                    </span>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
    );
  });
};

export default PlacementListingDetail;
